var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classnames,style:(`background-color:${_vm.color}`)},[(_vm.is_checked)?_c('svg-icon',{staticClass:"icon",attrs:{"name":"checked-circle"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }